import Vue from 'vue'
import VueRouter from 'vue-router'
import shHome from '@/components/Home'
import shNewUser from '@/components/pages/user/New'
import shUsers from '@/components/pages/user/Users'
import shUsersHistory from '@/components/pages/user/UsersHistory'

import shNewColor from '@/components/pages/color/New'
import shColors from '@/components/pages/color/Colors'
import shColorsHistory from '@/components/pages/color/ColorsHistory'

import shNewConfig from '@/components/pages/config/New'
import shConfigs from '@/components/pages/config/Configs'

import shNewDesign from '@/components/pages/design/New'
import shDesigns from '@/components/pages/design/Designs'
import shDesignsHistory from '@/components/pages/design/DesignsHistory'

import shNewSize from '@/components/pages/size/New'
import shSizes from '@/components/pages/size/Sizes'
import shSizesHistory from '@/components/pages/size/SizesHistory'

import shNewArticle from '@/components/pages/article/New'
import shArticles from '@/components/pages/article/Articles'
import shArticlesHistory from '@/components/pages/article/ArticlesHistory'

import shNewProduct from '@/components/pages/product/New'
import shProducts from '@/components/pages/product/Products'
import shProductsHistory from '@/components/pages/product/ProductsHistory'

import shNewMethod from '@/components/pages/method/New'
import shMethods from '@/components/pages/method/Methods'
import shMethodsHistory from '@/components/pages/method/MethodsHistory'

import shNewConveyor from '@/components/pages/conveyor/New'
import shConveyors from '@/components/pages/conveyor/Conveyors'
import shConveyorsHistory from '@/components/pages/conveyor/ConveyorsHistory'

import shNewLocation from '@/components/pages/location/New'
import shLocations from '@/components/pages/location/Locations'
import shLocationsHistory from '@/components/pages/location/LocationsHistory'

import shNewCode from '@/components/pages/code/New'
import shCodes from '@/components/pages/code/Codes'
import shCodesHistory from '@/components/pages/code/CodesHistory'

import shNewArticleDefault from '@/components/pages/articleDefault/New'
import shArticleDefaults from '@/components/pages/articleDefault/ArticleDefaults'
import shArticleDefaultsHistory from '@/components/pages/articleDefault/ArticleDefaultsHistory'

import shUploadImage from '@/components/pages/image/Upload'
import shImages from '@/components/pages/image/Images'
import shImagesHistory from '@/components/pages/image/ImagesHistory'

import shNewLabel from '@/components/pages/label/New'
import shLabels from '@/components/pages/label/Labels'
import shLabelsHistory from '@/components/pages/label/LabelsHistory'

import shNewTier from '@/components/pages/tier/New'
import shTiers from '@/components/pages/tier/Tiers'
import shTiersHistory from '@/components/pages/tier/TiersHistory'

import shNewTemporaryStock from '@/components/pages/temporaryStock/New'
import shTemporaryStocks from '@/components/pages/temporaryStock/TemporaryStocks'
import shTemporaryStockMovements from '@/components/pages/temporaryStock/Movements'
import shTemporaryStocksHistory from '@/components/pages/temporaryStock/TemporaryStocksHistory'

import shNewOrder from '@/components/pages/order/New'
import shOrders from '@/components/pages/order/Orders'
import shOrdersHistory from '@/components/pages/order/OrdersHistory'

import shOrdersDropshipping from '@/components/pages/orderDropshipping/OrdersDropshipping'

import shNewDelivery from '@/components/pages/delivery/New'
import shDeliveries from '@/components/pages/delivery/Deliveries'
import shPendingDeliveries from '@/components/pages/delivery/PendingDeliveries'
import shDeliveriesHistory from '@/components/pages/delivery/DeliveriesHistory'

import shRefunds from '@/components/pages/refund/Refunds'
import shRefundsHistory from '@/components/pages/refund/RefundsHistory'

import shBonuses from '@/components/pages/bonus/Bonuses'
import shNewBonus from '@/components/pages/bonus/New'

import shCustomers from '@/components/pages/customer/Customers'

import shInvoices from '@/components/pages/invoice/Invoices'
import shInvoicesHistory from '@/components/pages/invoice/InvoicesHistory'
import shInvoiceConveyor from '@/components/pages/invoice/conveyorInvoice'
import shInvoiceDianReceipt from '@/components/pages/invoice/DianReceipt'
import shIndividualInvoice from '@/components/pages/invoice/IndividualInvoice'

import shNewPrice from '@/components/pages/price/New'
import shPrices from '@/components/pages/price/Prices'
import shPricesHistory from '@/components/pages/price/PricesHistory'

import shEnterProducts from '@/components/pages/stock/Enter'

import shPrintLabels from '@/components/pages/print/PrintLabels'
import shPrintReturnAddress from '@/components/pages/print/PrintReturnAddress'
import shPrintReturnAddressChanges from '@/components/pages/print/PrintReturnAddressChanges'
import shPrintRemission from '@/components/pages/print/PrintRemission'
import shPageToPrint from '@/components/pages/print/PageToPrint'
import shPageToPrintEnum from '@/components/pages/print/PageToPrintEnum'

import shLogin from '@/components/pages/login/Login'
import shVerification from '@/components/pages/login/Verification'

import shNewOrderWholesaler from '@/components/pages/orderWholesaler/New'
import shOrderWholesalers from '@/components/pages/orderWholesaler/OrderWholesalers'

import shGiftVouchers from '@/components/pages/giftVoucher/GiftVouchers'
import shGiftMessages from '@/components/pages/giftMessage/GiftMessages'

import shNewFaq from '@/components/pages/faq/New'
import shFaqs from '@/components/pages/faq/Faqs'

import shNewFeedback from '@/components/pages/feedback/New'
import shFeedbacks from '@/components/pages/feedback/Feedbacks'

import shChanges from '@/components/pages/change/Changes'

import shLocationsIntegration from '@/components/pages/integrations/Locations'
import shProductsIntegration from '@/components/pages/integrations/Products'
import shOrdersIntegration from '@/components/pages/integrations/Orders'
import shDeliveriesIntegration from '@/components/pages/integrations/Deliveries'

import shReports from '@/components/pages/reports/Reports'
import shMetrics from '@/components/pages/metrics/Metrics'
import shReportSales from '@/components/pages/reports/Sales'
import shReportDeliveries from '@/components/pages/reports/Deliveries'
import shReportInvoices from '@/components/pages/reports/Invoices'
import shReportStock from '@/components/pages/reports/Stock'
import shInventoryEdit from '@/components/pages/inventory/edit/Edit'

import shTracking from '@/components/pages/others/Tracking'
import shActiveBrand from '@/components/pages/others/ActiveBrand'
import shWelivery from '@/components/pages/order/Welivery'
import shRodapp from '@/components/pages/order/Rodapp'
import shServientrega from '@/components/pages/order/Servientrega'
import shGuides from '@/components/pages/order/mass/Guides'
import shTrackingDelivery from '@/components/pages/order/mass/TrackingDelivery'
import shOrderPack from '@/components/pages/order/pack/Pack'
import shOrderDataNovelties from '@/components/pages/order/novelties/DataNovelties'

import shNewSet from '@/components/pages/set/New'
import shSets from '@/components/pages/set/Sets'

import shSaleDates from '@/components/pages/saleDates/SaleDates'
import shEcommerceConfig from '@/components/pages/ecommerceConfig/EcommerceConfig'
import shPaymentConfig from '@/components/pages/paymentConfig/PaymentConfig'
import shUpdatePrices from '@/components/pages/updatePrices/UpdatePrices'
import shFindTier from '@/components/pages/product/FindTier'
import shBans from '@/components/pages/ban/Bans'
import shFraudCases from '@/components/pages/fraudCase/FraudCases'
import shFraudCasesClosed from '@/components/pages/fraudCase/FraudCasesClosed'
import shFraudReports from '@/components/pages/fraudReport/FraudReports'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: shHome,
      redirect: '/metrics'
    },
    {
      path: '/metrics',
      name: 'Metrics',
      component: shMetrics
    },
    {
      path: '/login',
      name: 'Login',
      component: shLogin
    },
    {
      path: '/verification',
      name: 'Verification',
      component: shVerification
    },
    {
      path: '/new-user',
      name: 'NewUser',
      component: shNewUser
    },
    {
      path: '/users',
      name: 'Users',
      component: shUsers
    },
    {
      path: '/history-users',
      name: 'HistoryUsers',
      component: shUsersHistory
    },
    {
      path: '/new-color',
      name: 'NewColor',
      component: shNewColor
    },
    {
      path: '/colors',
      name: 'Colors',
      component: shColors
    },
    {
      path: '/changes',
      name: 'Changes',
      component: shChanges
    },
    {
      path: '/new-config',
      name: 'NewConfig',
      component: shNewConfig
    },
    {
      path: '/configs',
      name: 'Configs',
      component: shConfigs
    },
    {
      path: '/history-colors',
      name: 'HistoryColors',
      component: shColorsHistory
    },
    {
      path: '/new-design',
      name: 'NewDesign',
      component: shNewDesign
    },
    {
      path: '/designs',
      name: 'Designs',
      component: shDesigns
    },
    {
      path: '/history-designs',
      name: 'HistoryDesigns',
      component: shDesignsHistory
    },
    {
      path: '/new-article',
      name: 'NewArticle',
      component: shNewArticle
    },
    {
      path: '/articles',
      name: 'Articles',
      component: shArticles
    },
    {
      path: '/history-articles',
      name: 'HistoryArticles',
      component: shArticlesHistory
    },
    {
      path: '/new-faq',
      name: 'NewFaq',
      component: shNewFaq
    },
    {
      path: '/faqs',
      name: 'Faqs',
      component: shFaqs
    },
    {
      path: '/new-feedback',
      name: 'NewFeedback',
      component: shNewFeedback
    },
    {
      path: '/feedbacks',
      name: 'Feedbacks',
      component: shFeedbacks
    },
    {
      path: '/new-method',
      name: 'NewMethod',
      component: shNewMethod
    },
    {
      path: '/methods',
      name: 'Methods',
      component: shMethods
    },
    {
      path: '/history-methods',
      name: 'HistoryMethods',
      component: shMethodsHistory
    },
    {
      path: '/new-conveyor',
      name: 'NewConveyor',
      component: shNewConveyor
    },
    {
      path: '/conveyors',
      name: 'Conveyors',
      component: shConveyors
    },
    {
      path: '/history-conveyors',
      name: 'HistoryConveyors',
      component: shConveyorsHistory
    },
    {
      path: '/new-location',
      name: 'NewLocation',
      component: shNewLocation
    },
    {
      path: '/locations',
      name: 'Locations',
      component: shLocations
    },
    {
      path: '/history-locations',
      name: 'HistoryLocations',
      component: shLocationsHistory
    },
    {
      path: '/new-code',
      name: 'NewCode',
      component: shNewCode
    },
    {
      path: '/codes',
      name: 'Codes',
      component: shCodes
    },
    {
      path: '/history-codes',
      name: 'HistoryCodes',
      component: shCodesHistory
    },
    {
      path: '/new-image',
      name: 'UploadImage',
      component: shUploadImage
    },
    {
      path: '/images',
      name: 'Images',
      component: shImages
    },
    {
      path: '/history-images',
      name: 'HistoryImages',
      component: shImagesHistory
    },
    {
      path: '/new-articleDefault',
      name: 'NewArticleDefault',
      component: shNewArticleDefault
    },
    {
      path: '/articleDefaults',
      name: 'ArticleDefaults',
      component: shArticleDefaults
    },
    {
      path: '/history-articleDefaults',
      name: 'HistoryArticleDefaults',
      component: shArticleDefaultsHistory
    },
    {
      path: '/new-size',
      name: 'NewSize',
      component: shNewSize
    },
    {
      path: '/sizes',
      name: 'Sizes',
      component: shSizes
    },
    {
      path: '/history-sizes',
      name: 'HistorySizes',
      component: shSizesHistory
    },
    {
      path: '/new-product',
      name: 'NewProduct',
      component: shNewProduct
    },
    {
      path: '/products',
      name: 'Products',
      component: shProducts
    },
    {
      path: '/history-products',
      name: 'HistoryProducts',
      component: shProductsHistory
    },
    {
      path: '/new-label',
      name: 'NewLabel',
      component: shNewLabel
    },
    {
      path: '/labels',
      name: 'Labels',
      component: shLabels
    },
    {
      path: '/history-labels',
      name: 'HistoryLabels',
      component: shLabelsHistory
    },
    {
      path: '/new-tier',
      name: 'NewTier',
      component: shNewTier
    },
    {
      path: '/tiers',
      name: 'Tiers',
      component: shTiers
    },
    {
      path: '/history-tiers',
      name: 'HistoryTiers',
      component: shTiersHistory
    },
    {
      path: '/new-temporaryStock',
      name: 'NewTemporaryStock',
      component: shNewTemporaryStock
    },
    {
      path: '/temporaryStocks',
      name: 'TemporaryStocks',
      component: shTemporaryStocks
    },
    {
      path: '/temporaryStock-movements',
      name: 'TemporaryStockMovements',
      component: shTemporaryStockMovements
    },
    {
      path: '/history-temporaryStocks',
      name: 'HistoryTemporaryStocks',
      component: shTemporaryStocksHistory
    },
    {
      path: '/print-labels',
      name: 'PrintLabels',
      component: shPrintLabels
    },
    {
      path: '/print-return-address',
      name: 'PrintReturnAddress',
      components: {
        print: shPrintReturnAddress
      }
    },
    {
      path: '/print-return-address-changes',
      name: 'PrintReturnAddressChanges',
      components: {
        print: shPrintReturnAddressChanges
      }
    },
    {
      path: '/print-remission',
      name: 'PrintRemission',
      components: {
        print: shPrintRemission
      }
    },
    {
      path: '/page-to-print',
      name: 'PageToPrint',
      components: {
        print: shPageToPrint
      }
    },
    {
      path: '/page-to-print-enum/:type',
      name: 'PageToPrintEnum',
      components: {
        print: shPageToPrintEnum
      }
    },
    {
      path: '/enter-products',
      name: 'Enter Products',
      component: shEnterProducts
    },
    {
      path: '/new-order',
      name: 'NewOrder',
      component: shNewOrder
    },
    {
      path: '/orders',
      name: 'Orders',
      component: shOrders
    },
    {
      path: '/ordersDropshipping',
      name: 'OrdersDropshipping',
      component: shOrdersDropshipping
    },
    {
      path: '/history-orders',
      name: 'HistoryOrders',
      component: shOrdersHistory
    },
    {
      path: '/new-delivery',
      name: 'NewDelivery',
      component: shNewDelivery
    },
    {
      path: '/deliveries',
      name: 'Deliveries',
      component: shDeliveries
    },
    {
      path: '/deliveries/pending',
      name: 'PendingDeliveries',
      component: shPendingDeliveries
    },
    {
      path: '/history-deliveries',
      name: 'HistoryDeliveries',
      component: shDeliveriesHistory
    },
    {
      path: '/refunds',
      name: 'Refunds',
      component: shRefunds
    },
    {
      path: '/history-refunds',
      name: 'HistoryRefunds',
      component: shRefundsHistory
    },
    {
      path: '/bonuses',
      name: 'Bonuses',
      component: shBonuses
    },
    {
      path: '/new-bonus',
      name: 'NewBonus',
      component: shNewBonus
    },
    {
      path: '/customers',
      name: 'Customers',
      component: shCustomers
    },
    {
      path: '/invoices',
      name: 'Invoices',
      component: shInvoices
    },
    {
      path: '/invoiceConveyor',
      name: 'InvoiceConveyor',
      component: shInvoiceConveyor
    },
    {
      path: '/invoice-dian-receipt',
      name: 'InvoiceDianReceipt',
      component: shInvoiceDianReceipt
    },
    {
      path: '/invoice-individual',
      name: 'IndividualInvoice',
      component: shIndividualInvoice
    },
    {
      path: '/history-invoices',
      name: 'HistoryInvoices',
      component: shInvoicesHistory
    },
    {
      path: '/new-price',
      name: 'NewPrice',
      component: shNewPrice
    },
    {
      path: '/prices',
      name: 'Prices',
      component: shPrices
    },
    {
      path: '/history-prices',
      name: 'HistoryPrices',
      component: shPricesHistory
    },
    {
      path: '/new-orderWholesaler',
      name: 'NewOrderWholesaler',
      component: shNewOrderWholesaler
    },
    {
      path: '/orderWholesalers',
      name: 'OrderWholesalers',
      component: shOrderWholesalers
    },
    {
      path: '/giftVouchers',
      name: 'giftVouchers',
      component: shGiftVouchers
    },
    {
      path: '/giftMessages',
      name: 'giftMessages',
      component: shGiftMessages
    },
    {
      path: '/integrations/locations',
      name: 'LocationsIntegration',
      component: shLocationsIntegration
    },
    {
      path: '/integrations/products',
      name: 'ProductsIntegration',
      component: shProductsIntegration
    },
    {
      path: '/integrations/orders',
      name: 'OrdersIntegration',
      component: shOrdersIntegration
    },
    {
      path: '/integrations/deliveries',
      name: 'DeliveriesIntegration',
      component: shDeliveriesIntegration
    },
    {
      path: '/reports',
      name: 'Reports',
      component: shReports
    },
    {
      path: '/reports/sales',
      name: 'ReportSales',
      component: shReportSales
    },
    {
      path: '/reports/deliveries',
      name: 'ReportDeliveries',
      component: shReportDeliveries
    },
    {
      path: '/reports/invoices',
      name: 'ReportInvoices',
      component: shReportInvoices
    },
    {
      path: '/reports/stock',
      name: 'ReportStock',
      component: shReportStock
    },
    {
      path: '/inventory/edit',
      name: 'InventoryEdit',
      component: shInventoryEdit
    },
    {
      path: '/others/tracking',
      name: 'Tracking',
      component: shTracking
    },
    {
      path: '/others/active-brand',
      name: 'ActiveBrand',
      component: shActiveBrand
    },
    {
      path: '/orders/welivery',
      name: 'Welivery',
      component: shWelivery
    },
    {
      path: '/orders/rodapp',
      name: 'Rodapp',
      component: shRodapp
    },
    {
      path: '/orders/servientrega',
      name: 'Servientrega',
      component: shServientrega
    },
    {
      path: '/orders/guides',
      name: 'OrderGuides',
      component: shGuides
    },
    {
      path: '/orders/pack/:code?',
      name: 'OrderPack',
      component: shOrderPack
    },
    {
      path: '/orders/novelties/product/:code',
      redirect: to => `/orders/novelties/${to.params.code}`
    },
    {
      path: '/orders/novelties/data/:code',
      redirect: to => `/orders/novelties/${to.params.code}`
    },
    {
      path: '/orders/novelties/:code?',
      name: 'OrderDataNovelties',
      component: shOrderDataNovelties
    },
    {
      path: '/orders/tracking-delivery',
      name: 'TrackingDeliveryPrint',
      components: {
        print: shTrackingDelivery
      }
    },
    {
      path: '/new-set',
      name: 'NewSet',
      component: shNewSet
    },
    {
      path: '/sets',
      name: 'Sets',
      component: shSets
    },
    {
      path: '/sale-dates',
      name: 'SaleDates',
      component: shSaleDates
    },
    {
      path: '/payment-config',
      name: 'PaymentConfig',
      component: shPaymentConfig
    },
    {
      path: '/ecommerce-config',
      name: 'EcommerceConfig',
      component: shEcommerceConfig
    },
    {
      path: '/update-prices',
      name: 'UpdatePrices',
      component: shUpdatePrices
    },
    {
      path: '/find-tier',
      name: 'FindTier',
      component: shFindTier
    },
    {
      path: '/bans',
      name: 'Bans',
      component: shBans
    },
    {
      path: '/fraud-cases',
      name: 'FraudCases',
      component: shFraudCases
    },
    {
      path: '/fraud-cases-closed',
      name: 'FraudCasesClosed',
      component: shFraudCasesClosed
    },
    {
      path: '/fraud-reports',
      name: 'FraudReports',
      component: shFraudReports
    }
  ],

  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js